module.exports = __webpack_public_path__ + "static/media/venue_jiu03.79338bc8.jpg";